import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CcExpiryValidatorDirective } from './cc-expiry-validator.directive';
import { DecimalValidatorDirective } from './decimal-validator.directive';
import { EmailValidatorDirective } from './email-validator.directive';
import { IntValidatorDirective } from './int-validator.directive';
import { PasswordValidatorDirective } from './password-validator.directive';
import { MaxCharactersValidatorDirective } from './max-characters-validator.directive';
import { PhoneValidatorDirective } from './phone-validator.directive';
import { PostalCodeValidatorDirective } from './postal-code-validator.directive';
import { AlphaNumericAndSafeSymbolsValidatorDirective } from './alphanumeric-and-safe-symbols-validator.directive';
import { TINValidatorDirective } from './tin-validator.directive';
import { PasswordMatchValidatorDirective } from './password-match-validator.directive';

@NgModule({
    imports: [CommonModule],
    declarations: [
        AlphaNumericAndSafeSymbolsValidatorDirective,
        CcExpiryValidatorDirective,
        DecimalValidatorDirective,
        EmailValidatorDirective,
        IntValidatorDirective,
        PasswordMatchValidatorDirective,
        PasswordValidatorDirective,
        PhoneValidatorDirective,
        MaxCharactersValidatorDirective,
        PostalCodeValidatorDirective,
        TINValidatorDirective,
    ],
    exports: [
        AlphaNumericAndSafeSymbolsValidatorDirective,
        CcExpiryValidatorDirective,
        DecimalValidatorDirective,
        EmailValidatorDirective,
        IntValidatorDirective,
        PasswordMatchValidatorDirective,
        PasswordValidatorDirective,
        PhoneValidatorDirective,
        MaxCharactersValidatorDirective,
        PostalCodeValidatorDirective,
        TINValidatorDirective,
    ],
})
export class StringValidatorsModule
{
}
